import { render, staticRenderFns } from "./EditStaticAssessment.vue?vue&type=template&id=029d5eba&scoped=true&"
import script from "./EditStaticAssessment.vue?vue&type=script&lang=js&"
export * from "./EditStaticAssessment.vue?vue&type=script&lang=js&"
import style0 from "./EditStaticAssessment.vue?vue&type=style&index=0&id=029d5eba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029d5eba",
  null
  
)

export default component.exports